var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import BemClassBuilder from '../../../core/utils/src/class-builders/bem';
import { Button } from '../../button/src';
import { Icon } from '../../icon/src';
import { clamp } from './utils';
var MAX_VALUE = 100;
var controlId = 0;
export var ProgressBar = AwsUi.__addComponent('awsui-progress-bar', {
    releaseStatus: 'stable',
    events: {
        // Fired when the user triggers the result state button.
        resultButtonClick: {
            cancelable: false
        }
    },
    properties: {
        // Percentage value of the progress. Will be clamped between 0 and 100. Decimals will be rounded.
        value: {
            type: 'integer',
            defaultValue: 0
        },
        // Use `"in-progress"` to display a progress bar.
        // `"success"` and `"error"` are result states and replace the progress element with a status indicator,
        // `resultText` and, if set, with a button containing `resultButtonText`.
        status: {
            type: 'string',
            valid: ['in-progress', 'success', 'error'],
            defaultValue: 'in-progress'
        },
        // Allows the correct styling of the progress bar in different contexts.
        // Set it to `"flash"` when using the progress bar within a flash component.
        // Set it to `"key-value"` when using it within the key-value pairs pattern. Set it to `"standalone"` in all other cases.
        variant: {
            type: 'string',
            valid: ['standalone', 'flash', 'key-value'],
            required: true
        },
        // Text for the button that gets displayed when `status` is set to `"error"` or `"success"`.
        // If `resultButtonText` is empty, no button will be displayed.
        resultButtonText: {
            type: 'string'
        }
    },
    regions: {
        // Short information summarizing the operation. Rendered at the top of the component.
        label: {},
        // More detailed information about the operation, rendered between the progress bar and label.
        description: {},
        // Information that is displayed below the progress bar.
        additionalInfo: {},
        // Content that is displayed whenever `status` is set to `"error"` or `"success"`.
        resultText: {}
    },
    callbacks: {
        initialized: function () {
            this.__controlId = "awsui-progress-bar-" + controlId++;
        }
    },
    render: function (m, h) {
        var _this = this;
        var progressBar = function () {
            var roundedValue = Math.round(_this.value);
            var value = clamp(roundedValue, 0, MAX_VALUE);
            return (AwsUi.__createElement("div", { className: new BemClassBuilder(_this, 'container').toString() },
                AwsUi.__createElement("progress", { className: new BemClassBuilder(_this, 'progress').toString(), value: value, max: MAX_VALUE, "aria-valuetext": _this.value + "%", "aria-labelledby": _this.__controlId + "-label" }),
                AwsUi.__createElement("small", { className: new BemClassBuilder(_this, 'percentage').toString(), "aria-hidden": "true" }, value + "%")));
        };
        var resultButton = function () {
            var trigger = function () { return _this.__fireEvent('resultButtonClick'); };
            return (AwsUi.__createElement(Button, { className: "awsui-util-ml-m awsui-progress-bar__result-button", text: _this.resultButtonText, click: trigger, formAction: "none" }));
        };
        var resultState = function (isInFlash) {
            var resultClass = _this.status === 'success' ? 'positive' : 'negative';
            var ariaProps = {
                'aria-labelledby': _this.__controlId + "-label",
                'aria-live': 'polite',
                'aria-atomic': 'true'
            };
            if (isInFlash) {
                return h.region('resultText', 'span', ariaProps);
            }
            return (AwsUi.__createElement("div", __assign({ className: "awsui-util-status-" + resultClass }, ariaProps),
                AwsUi.__createElement(Icon, { name: "status-" + resultClass }),
                " ",
                h.region('resultText', 'span'),
                _this.resultButtonText ? resultButton() : null));
        };
        var rootClasses = new BemClassBuilder(this);
        if (this.variant) {
            rootClasses.modifier(this.variant);
        }
        var isInFlash = this.variant === 'flash';
        var isInResultState = this.status !== 'in-progress';
        return (AwsUi.__createElement("span", { className: rootClasses.toString() },
            AwsUi.__createElement("div", { className: new BemClassBuilder(this, 'progress-container') },
                h.region('label', 'label', {
                    className: new BemClassBuilder(this, 'label').toString() + " " + (this.variant === 'key-value' ? 'awsui-util-label' : ''),
                    id: this.__controlId + "-label"
                }),
                AwsUi.__createElement("small", { className: new BemClassBuilder(this, 'description').toString() }, h.region('description')),
                !isInResultState ? progressBar() : resultState(isInFlash),
                AwsUi.__createElement("small", { className: new BemClassBuilder(this, 'additional-info').toString() }, h.region('additionalInfo'))),
            isInResultState && isInFlash && this.resultButtonText ? resultButton() : null));
    }
});
//# sourceMappingURL=index.js.map